var map = {
	"./bg20.jpg": 51769,
	"./br/PT/S1/bg20.jpg": 81891,
	"./br/PT/S2/bg20.jpg": 22527,
	"./in/EN/S1/bg20.jpg": 95349,
	"./in/EN/S2/bg20.jpg": 46873,
	"./in/HI/S1/bg20.jpg": 5617,
	"./mx/EN/S1/bg20.jpg": 39155,
	"./ng/EN/S1/bg20.jpg": 42002,
	"./ph/EN/S1/bg20.jpg": 33528,
	"./vn/VI/S1/bg20.jpg": 95120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48473;